import React from 'react'
import { connect } from 'react-redux'
import CouponActions from '../../Redux/CouponRedux'

class DownloadHistory extends React.Component {
  constructor (props) {
    super (props)
    this.types = [
      { value: 'BUSINESS', label: 'Business' },
      { value: 'GENERIC', label: 'Generic' }
    ]
    this.state = {
      type: 'BUSINESS',
      tag: props.tag || '-',
      isSubmitted: false,
      downloadLink: null
    }
  }

  componentWillReceiveProps = (newProps) => {
    if (this.state.isSubmitted && newProps.coupon.spreadsheet) {
      this._downloadLink(newProps.coupon.spreadsheet)
    }
  }

  componentDidMount = () => {
    this._submit()
  }

  _downloadLink = (data = null) => {
    let downloadLink = data
    this.setState({ downloadLink })
    if (data) {
      this.props.closeModal()
    }
  }

  _inputChange = (event, field) => {
    const val = event.target.value
    let newState = {...this.state}
    newState[field] = val
    this.setState(newState)
  }

  _submit = (event) => {
    if (event) event.preventDefault()
    const { type, tag } = this.state
    const data = { type, tag }
    this.setState({ isSubmitted: true })
    this.props.generateSpreadsheet(data)
  }

  render () {
    return (
      <section className="section" style={{ width: '30vw' }}>
        <div className="title-block">
          <h3 className="title">Download History</h3>
        </div>
        <div className="form-group text-center">
          {
            (this.state.downloadLink) ?
              'The file is being downloaded'
            :
              'Generating ...'
          }
        </div>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  coupon: state.coupon
})

const dispatchToProps = (dispatch) => ({
  generateSpreadsheet: (data) => dispatch(CouponActions.historySpreadsheetRequest(data))
})

export default connect(stateToProps, dispatchToProps)(DownloadHistory)



// WEBPACK FOOTER //
// ./src/Containers/Coupon/DownloadHistory.js